import { useToggleTypes } from 'hooks';

export default (editor) => {
  const cm = editor.Commands;

  cm.add('qr', {
    run(editor) {
      const target = editor.getModel();

      target.get('onShow')(useToggleTypes.showQRModal);
    },
  });
};
